<template>
  <jw-select v-model="selectVal" @change="changeSelect" :placeholder="propData.placeholder || $t('请选择')" :allow-clear="propData.allowClear === false ? false : true" :multiple="propData.multiple === true ? true : false" :max-tag-count="propData.maxTagCount === undefined ? 1 : propData.maxTagCount" :bordered="propData.bordered === false ? false : true" :allow-search="allowSearch" :field-names="propData.dataProps" :popup-containter="propData.target || 'body'" v-on="extraFn" v-bind="extraAttrs" :trigger-props="{ updateAtScroll: true }">
    <jw-option v-for="item in options" :key="item?.[propData?.dataProps?.value || 'value']" :value="item?.[propData?.dataProps?.value || 'value']" :class="{ 'item-isEnabled': item?.isEnabled === false }">{{ item?.[propData?.dataProps?.label || 'label'] }}</jw-option>
  </jw-select>
</template>

<script setup>
// 后续等需要远程搜索的时候可以增加远程搜索的相关功能
// import { reactive, toRefs } from 'vue';
import { ref, computed, watchEffect } from 'vue';
const props = defineProps({
  subcol: {
    type: Object,
    default() {
      return {};
    }
  }
});
const propData = computed(() => {
  let c = props.subcol;
  // console.log(39, props.subcol.type);
  if (props.subcol.type === 'checkbox') {
    c = Object.assign(
      { ...props.subcol },
      {
        type: 'select',
        multiple: true,
        maxTagCount: 2
      }
    );
  }
  if (props.subcol.type === 'radio') {
    c = Object.assign(
      { ...props.subcol },
      {
        type: 'select'
      }
    );
  }
  // console.log(391, props.subcol, props.subcol.type);
  return c;
});
console.log(392, propData.value);
const emits = defineEmits(['cb']);
const selectVal = ref(propData.value.value ?? (propData.value.multiple ? [] : ''));
const options = ref(propData.value.data || []);
// 是否允许搜索，单选默认不允许，多选默认允许，用户可以自己定义是否允许
const allowSearch = computed(() => {
  let flag = true;
  if (propData.value.multiple) flag = true;
  else flag = false;
  if (propData.value.allowSearch === false) flag = false;
  if (propData.value.allowSearch === true) flag = true;
  return flag;
});
console.log(29, '11111', selectVal.value);
watchEffect(() => {
  options.value = propData.value.data || [];
  selectVal.value = propData.value.value ?? '';
  if (propData.value.multiple) {
    selectVal.value = propData.value.value || [];
  }
});

// 其他属性 远程加载数据
const search = computed(() => propData.value.search || undefined);
const extraFn = ref({});
const extraAttrs = ref({});
if (search.value) {
  extraFn.value = {
    search: async (v) => {
      if (v) {
        const json = await search.value({});
        console.log(45, json?.result);
        if (Array.isArray(json?.result)) {
          // options.value = json?.result || [{name:'大萨达多',id: 123}];
          options.value = json?.result || [];
        }
      } else {
        options.value = propData.value.data || [];
      }
    }
  };
  extraAttrs.value = {
    filterOption: propData.value.filterOption || false
  };
}

// subcol.allowSearch === false ? false : subcol.allowSearch === undefined ? true : subcol.allowSearch
// select 事件
const changeSelect = async (v) => {
  const o = {};
  console.log(26533, v);
  let pv = v;
  if (propData.value.multiple) {
    if (pv.length === 0) pv = undefined;
  } else {
    if (pv === '') {
      pv = undefined;
      // 远程
      if (search.value) {
        // 增加恢复默认数据功能；
        extraFn.value?.search(pv);
      }
    }
  }

  o[propData.value.name] = pv;
  console.log(26534, JSON.stringify(o));
  emits('cb', o, 1);
};
</script>
<style scoped lang="less">
@import './xl-select.less';
</style>
